import { useEffect } from "react";
import { useDispatch } from "react-redux";
import SubBanner from "../../comm/SubBanner";
import SubMenu from "../../comm/SubMenu";
import Location from "../../comm/Location";

function Directions(props) {
  const dispatch = useDispatch();

  useEffect(
    () => {
      dispatch({
        type: "pageChange",
        payload: { sub01: "조합소개", sub02: "찾아오시는 길" },
      });
      dispatch({ type: "loadingChange", payload: true });

      setTimeout(() => {
        dispatch({ type: "loadingChange", payload: false });
      }, 500);
    },
    // eslint-disable-next-line
    []
  );

  return (
    <>
      <SubBanner id="intro" />

      <section className="intro section">
        <div className="container">
          <div className="row">
            <div className="col-lg-9">
              <div className="row">
                <div className="col-12">
                  <h2>찾아오시는 길</h2>
                  방문시 위치를 미리 확인하셔서 오시기 바랍니다.
                </div>
              </div>

              <div className="row pt-30">
                <div className="col-12">
                  <Location />
                </div>
              </div>

              <div className="row pt-30">
                <div className="col-12">
                  <h5 className="sub-title">주소</h5>
                </div>
              </div>

              <div className="row pt-20">
                <div className="col-12">
                  <p>강원특별자치도 춘천시 동면 만천로 57</p>
                </div>
              </div>

              <div className="row pt-30">
                <div className="col-12">
                  <h5 className="sub-title">대중교통</h5>
                </div>
              </div>

              <div className="row pt-20">
                <div className="col-12">
                  <i className="icofont-bus-alt-3 green-bus-icon"></i> 4, 200-1
                  → 유앤아이아파트 하차
                </div>
                <div className="col-12">
                  <i className="icofont-bus-alt-3 green-bus-icon"></i> 400 →
                  아이파크아파트 하차
                </div>
              </div>
            </div>

            <SubMenu id="intro" />
          </div>
        </div>
      </section>
    </>
  );
}

export default Directions;
